import { Injectable, signal } from '@angular/core';

import { ContentLanguage } from './course-content.service';
import { LocalStorageLearnerStorage } from './learner-storage';

@Injectable({ providedIn: 'root' })
export class ContentLanguageService {
  private readonly learnerStorage = new LocalStorageLearnerStorage();
  private readonly languageSignal = signal<ContentLanguage>(this.loadInitial());

  readonly current = this.languageSignal.asReadonly();

  setLanguage(language: ContentLanguage): void {
    this.languageSignal.set(language);
    this.learnerStorage.savePreferences({
      ...this.learnerStorage.loadPreferences(),
      language: language.toLowerCase() as 'de' | 'en',
    });
  }

  private loadInitial(): ContentLanguage {
    return this.learnerStorage.loadPreferences().language === 'en' ? 'EN' : 'DE';
  }
}
